export const OVERVIEW_SLUG = 'overview';
export const WHATS_NEXT_SLUG = 'whats-next';
export const NEXT_PUBLIC_HIGHLIGHT_PROJECT_ID = 'ldwwonkd';